import React, { createContext, useContext, useState, useCallback } from "react";
import { Backdrop, CircularProgress } from "@mui/material";

// Create a context for the backdrop
const BackdropContext = createContext();

// Create a provider component for the backdrop
export const BackdropProvider = ({ children }) => {
  // State to manage the backdrop open state
  const [open, setOpen] = useState(false);

  // Function to show the backdrop
  const showBackdrop = useCallback(() => {
    setOpen(true);
  }, []);

  // Function to hide the backdrop
  const hideBackdrop = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <BackdropContext.Provider value={{ showBackdrop, hideBackdrop }}>
      {/* Render any children components wrapped by this provider */}
      {children}

      {/* Render the backdrop component */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1 }}
        open={open}
      >
        <CircularProgress
          size={50}
          style={{ color: "#FFF" }}
          thickness={4}
        />
      </Backdrop>
    </BackdropContext.Provider>
  );
};

// Custom hook to use the backdrop context
export const useBackdrop = () => {
  return useContext(BackdropContext);
};
